import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { onRestore } from 'modules/conference/actions/offlineHandlers';

import NoInternetPage from './NoInternetPage';

export default compose(
  connect(
    (state) => ({
      appointmentId: state.appointmentInfo.currentAppointment.appointmentId,
    }),
    { onRestore },
  ),
)(injectIntl(NoInternetPage));
